module.exports = __webpack_public_path__ + "static/media/Store_Percent_Ribbon_Red.0ac6ab9f.png";